import React from 'react'
import Helmet from 'react-helmet'
import { actions } from 'alelo-logic'
import { connect } from 'react-redux'
import EditAdminContactForm from '../../modules/EditAdminContactForm'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import { startSaving, stopSaving } from '../../modules/form-state-actions'
import contactFactory from './factory'

import { Content, Heading, Paragraph, Wrapper } from '../EditUserData/styles'

import {
  helmetTitle,
  title,
  subtitle,
  modalTitle,
  modaTitleError,
  modaTextError
} from './data.json'

import image from '../../../static/confirmation.png'

const { fetchUpdateBusinessContact } = actions

class EditAdminContact extends React.Component {
  state = {
    initialValues: null
  }

  componentDidMount() {
    this.setState({ initialValues: contactFactory.toForm(this.props.contacts) })
  }

  componentDidUpdate(prevProps) {
    const { contacts, history } = this.props
    if (prevProps.contacts !== contacts) {
      this.setState({ initialValues: contactFactory.toForm(contacts) })
    }
    if (
      contacts &&
      prevProps.contacts &&
      prevProps.contacts.email.enderecoEletronico !== contacts.email.enderecoEletronico
    ) {
      window.setTimeout(() => {
        actions.fetchLogout()
        history.push('/conta/login')
      }, 4000)
    }
  }

  handleSave = contacts => {
    const { handleSave, dispatch } = this.props
    dispatch(startSaving())
    handleSave(contacts)
      .then(resp => {
        dispatch(showModal(CONFIRM_UPDATE, { modalTitle, image }))
      })
      .catch(e => {
        console.log('Erro na promise erro ao salvar', e)
        dispatch(
          showModal(CONFIRM_UPDATE, {
            modalTitle: modaTitleError,
            modalDescription: modaTextError,
            image
          })
        )
      })
      .finally(() => dispatch(stopSaving()))
  }

  render() {
    const { initialValues } = this.state
    return (
      <section>
        <Helmet title={helmetTitle} />
        <Content>
          <Heading>{title}</Heading>
          <Paragraph>{subtitle}</Paragraph>
        </Content>
        <Wrapper>
          <EditAdminContactForm
            initialValues={initialValues}
            onSubmit={values => this.handleSave(contactFactory.toAPI(values))}
            {...this.props}
          />
        </Wrapper>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  contacts: state.reducer.user.contato,
  saving: state.reducer.formState.saving
})

const mapDispatchToProps = dispatch => ({
  initFormState: () => dispatch(stopSaving()),
  handleSave: contacts => dispatch(fetchUpdateBusinessContact(contacts)),
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(EditAdminContact)



// WEBPACK FOOTER //
// ./src/app/pages/EditAdminContact/index.js